/*
  共通
  ヘッダーのアコーディオン設定
*/
$('.open').on('click', function () {
  $('.accordion-area').slideDown();
  $('.open, .header .pricelist, .header .search__btn').hide();
  $('.close').show();
  //$('html').css('overflow','hidden');
  $('.header-overlay').css('display', 'block');
});
$('.search-open').on('click', function () {
  $('.search').slideDown();
  $('.search-open, .pricelist, .open').hide();
  $('.search-close').show();
  //$('html').css('overflow','hidden');
  $('.header-overlay').css('display', 'block');
});
$('.search-close, .close, .js-contact, .header-overlay, .js-contact a').on('click', function () {
  $('.accordion-area, .search').slideUp();
  $('.search-close, .close').hide();
  $('.search-open, .open, .pricelist, .header .search__btn').show();
  //$('html').css('overflow','auto');
  $('.header-overlay').css('display', 'none');
});

/*
  共通
  アンカーリンク
*/
$("a[href^='#']").click(function () {
  var speed = 500;
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top;
  $("html, body").animate({
    scrollTop: position
  }, speed, "swing");
  return false;
});
$(window).on('load', function () {
  var url = $(location).attr('href');
  if (url.indexOf("?id=") != -1) {
    var id = url.split("?id=");
    var $target = $('#' + id[id.length - 1]);
    if ($target.length) {
      var pos = $target.offset().top;
      $("html, body").animate({
        scrollTop: pos
      }, 500);
    }
  }
});

/*
  共通
  スクロールイベント
*/
$('.typ').children().andSelf().contents().each(function () {
  if (this.nodeType == 3) {
    $(this).replaceWith($(this).text().replace(/(\S)/g, '<span>$1</span>'));
  }
});
$('.js-inview').on('inview', function (event, isInView, visiblePartX, visiblePartY) {
  if (isInView) {
    $(this).stop().addClass('animated');
    $('.typ', this).css({
      'opacity': 1
    });
    for (var i = 0; i <= $('.typ', this).children().size(); i++) {
      $('.typ', this).children('span:eq(' + i + ')').delay(100 * i).animate({
        'opacity': 1
      }, 300);
    };
  } else {
    $(this).stop().removeClass('animated');
    $('.typ,.typ span', this).css({
      'opacity': 0
    });
  }
});

/*
  共通
  hoverの処理設定
*/
var touch = 'ontouchstart' in document.documentElement ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

if (touch) { // remove all :hover stylesheets
  try { // prevent exception on browsers not supporting DOM styleSheets properly
    for (var si in document.styleSheets) {
      var styleSheet = document.styleSheets[si];
      if (!styleSheet.rules) continue;

      for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
        if (!styleSheet.rules[ri].selectorText) continue;

        if (styleSheet.rules[ri].selectorText.match(':hover')) {
          styleSheet.deleteRule(ri);
        }
      }
    }
  } catch (ex) {}
}

/*
  共通
  半角スペースで、display:inline-block
*/
$(function () {
  $(".js-name").lettering('words');
  $('.header').midnight();
});



/*
  追従サイドナビ
  電話アイコンを押した時の処理
*/
$('.fix-contact002 li a[href^="javascript:void(0)"]').on('click', function () {
  $('.fix-contact002').removeClass('active');
  $('.fix-contact').addClass('active');
});



/*
  お問い合わせフォーム
  オートコンプリート機能の無効化
*/
$('#contact input').attr({
  'autocomplete': 'off'
});

/*
  お問い合わせフォーム
  「お問合せ項目」の挙動設定
*/
$(document).ready(function () {
  $('.js-select').minimalect({
    placeholder: "選択してください"
  });
  $('.minict_wrapper ul').addClass('active');
  $('.minict_wrapper span').attr("contenteditable", "false");
  $('.minict_wrapper span').on('click', function () {
    $('.minict_wrapper ul').toggleClass('active');
  });
  $('#contact,.minict_wrapper ul').on('click', function () {
    $('.minict_wrapper ul').addClass('active');
  });
});

/*
  お問い合わせフォーム
  「お問合せ項目」を選んだ際の処理
*/
//$(document).ready(function() {
//  $('.minict_wrapper ul li').each(function(){
//    var savettl = localStorage.getItem('pagettl');
//    $(this).on('click',function(){
//      var text = $(this).text();
//      if(text.match(/RENTAL/)){
//        if(savettl) {
//          $('.wpcf7-textarea').text('商品名：' + savettl);
//        }
//      } else {
//        $('.wpcf7-textarea').text('');
//      }
//    });
//  });
//});

/*
  お問い合わせフォーム
  コンテンツ部分の非表示
*/
$('#contact .contact__btn').on('click', function () {
  if ($('#contact input').addClass('wpcf7c-conf')) {
    $('#contact .contents-inner').addClass('is-conf');
    $('.contact-none').css('display', 'none');
    $('.fix-contact').css('display', 'none');
    $('#page').css({
      "padding-bottom": '0',
      "margin-bottom": '0',
    });
  }
});



/*
  トップ
  ローディング画面
*/
// $(function () {
//   setTimeout(function () {
//     $('.loading').fadeOut();
//   }, 2000);
// });

/*
  トップ
  タブレット時のスクロールイベント処理(Rental〜のぼかし)
*/
var ua = navigator.userAgent;
if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
  $('.js-inview,.detail__btn').addClass('is-sp');
} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
  $('.js-inview,.detail__btn').addClass('is-sp');
} else {
  $('.js-inview').removeClass('is-sp');
  $('.detail__btn').addClass('is-pc');
}

/*
  トップ
  トピックス用スライダー
*/
var mySwiper = new Swiper('.js-slider01', {
  loop: true,
  slidesPerView: 4,
  spaceBetween: -1,
  paginationClickable: true,
  nextButton: '.swiper-button-next',
  prevButton: '.swiper-button-prev',
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 15,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    }
  }
})
/*
  トップ
  FEATURE用スライダー
*/
var mySwiper2 = new Swiper('.js-slider02', {
  loop: true,
  slidesPerView: 4,
  spaceBetween: -1,
  paginationClickable: true,
  nextButton: '.swiper-button-next',
  prevButton: '.swiper-button-prev',
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 15,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    }
  }
})

/*
  トップ
  メインビジュアル動画
*/
//$('#js-mainvisualVideo').YTPlayer();
//if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
//  $('.mv__video-wrap').html('');
//} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
//  $('.mv__video-wrap').html('');
//} else {
//}
$(window).on('load',function(){
  $('.mv__video').fadeIn();
});



/*
  Rental 一覧
  サイドナビの追従設定
*/
var rental_list = function () {
  var sns = $(".rental-list-left"),
    offset = sns.offset();

  $(window).on('load scroll', function () {
    var snsBottom = sns.height() + $(this).scrollTop();
    var parentBottom = $('.rental-list-wrap').offset().top + $('.rental-list-wrap').height();

    if ($(window).scrollTop() > offset.top - 100) {
      if (parentBottom < snsBottom + 200) {
        // 『変数 sns』のcssを変更
        sns.removeClass('is-fixed01').removeClass('is-fixed02').removeClass('is-fixed03');
        sns.addClass('is-fixed01');
      } else {
        sns.removeClass('is-fixed01').removeClass('is-fixed02').removeClass('is-fixed03');
        sns.addClass('is-fixed02');
      }
    } else {
      sns.removeClass('is-fixed01').removeClass('is-fixed02').removeClass('is-fixed03');
      sns.addClass('is-fixed03');
    }
  });
};



/*
  Rental 詳細
  スライダー設定
*/
$(window).on('load', function () {
  $('.js-slider03').bxSlider({
    mode: 'fade',
    controls: false,
    pagerCustom: '.bx-pager',
    speed: 800
  });
});

/*
  Rental 詳細
  タブ機能
*/
$('.detail-table-list li,.access-sec002-list a').each(function () {
  $(this).on('click', function () {
    $('.detail-table-list li').removeClass('active');
    $(this).addClass('active');
    if ($(this).hasClass('box001')) {
      $('.detail-table-box,.access-mv li').removeClass('active');
      $('.detail-table-box.box001,.access-mv li.box001').addClass('active');
    }
    if ($(this).hasClass('box002')) {
      $('.detail-table-box,.access-mv li').removeClass('active');
      $('.detail-table-box.box002,.access-mv li.box002').addClass('active');
    }
    if ($(this).hasClass('box003')) {
      $('.detail-table-box').removeClass('active');
      $('.detail-table-box.box003').addClass('active');
    }
  });
});

/*
  Rental 詳細
  テーブルのスクロール用テキスト表示
*/
$('table').before('<p class="js-note" style="margin-bottom:10px;">横スクロールでご確認いただけます</p>');
$(window).on('load resize', function () {
  var w = $(window).width();
  var x = 1140;
  if (x > w) {
    $('.js-note').css('display', 'block');
  } else {
    $('.js-note').css('display', 'none');
  }
});



/*
  Shop
  Moreボタンの処理
*/
var listContents = $('.shop-list li').length;
var Num = 16;
$('.shop-list li:not(:lt(' + Num + '))').addClass('dispnone');
if (listContents <= Num) {
  $('.shop__btn').hide();
}
$('.shop__btn').on('click', function () {
  Num += 8;
  $('.shop-list li:lt(' + Num + ')').removeClass('dispnone');
  //liの個数よりNumが多い時、
  if (listContents <= Num) {
    $('.shop__btn').hide();
  }
});



/*
  Access
  マップ設定(東京)
*/
function googleMap() {
  var latlng = new google.maps.LatLng(35.660304, 139.742436);
  var myOptions = {
    zoom: 16,
    center: latlng,
    mapTypeControlOptions: {
      mapTypeIds: ['style', google.maps.MapTypeId.ROADMAP]
    }
  };
  var map = new google.maps.Map(document.getElementById('map1'), myOptions);
  var icon = new google.maps.MarkerImage('/_assets/images/access/icon_map.png?v3',
    new google.maps.Size(28, 41),
    new google.maps.Point(0, 0)
  );
  var markerOptions = {
    position: latlng,
    map: map,
    icon: icon,
    title: '有限会社 特殊映材社',
    animation: google.maps.Animation.DROP
  };
  var marker = new google.maps.Marker(markerOptions);
  var styleOptions = [{
    'stylers': [{
      'gamma': 0.8
    }, {
      'saturation': -200
    }]
  }]
  var styledMapOptions = {
    name: '有限会社 特殊映材社'
  }
  var sampleType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
  map.mapTypes.set('style', sampleType);
  map.setMapTypeId('style');
};


/*
  Access
  マップ設定(札幌)
*/
function googleMap02() {
  var latlng = new google.maps.LatLng(43.056371, 141.30456);
  var myOptions = {
    zoom: 16,
    center: latlng,
    mapTypeControlOptions: {
      mapTypeIds: ['style', google.maps.MapTypeId.ROADMAP]
    }
  };
  var map = new google.maps.Map(document.getElementById('map2'), myOptions);
  var icon = new google.maps.MarkerImage('/_assets/images/access/icon_map.png?v3',
    new google.maps.Size(28, 41),
    new google.maps.Point(0, 0)
  );
  var markerOptions = {
    position: latlng,
    map: map,
    icon: icon,
    title: '有限会社 特殊映材社',
    animation: google.maps.Animation.DROP
  };
  var marker = new google.maps.Marker(markerOptions);
  var styleOptions = [{
    'stylers': [{
      'gamma': 0.8
    }, {
      'saturation': -200
    }]
  }]
  var styledMapOptions = {
    name: '有限会社 特殊映材社'
  }
  var sampleType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
  map.mapTypes.set('style', sampleType);
  map.setMapTypeId('style');
};
